import Vue from 'vue'
import { HawaPanel } from './types'

import IOField from './io-field'
import IOFieldV from './io-field-v'
import GoogleMap from './google-map'
import TableDatalog from './table-datalog'
// import TrendObject from './trend-object'
import TrendingLine from './trending-line'
import TextObject from './text-object'
import GaugeObject from './gauge-object'
import HistoricalTrend from './historical-trend'

import HistoricalAlarm from './historical-alarm'
// import RealtimeTagTable from './table-rt'

import ScalableVectorGraphics from './scalable-vector-graphics'

const Panels: typeof HawaPanel[] = [
  // TrendObject,
  TableDatalog,
  IOField,
  IOFieldV,
  HistoricalTrend,
  HistoricalAlarm,
  TextObject,
  GoogleMap,
  GaugeObject,
  TrendingLine,
  ScalableVectorGraphics,
  // RealtimeTagTable,
  // TankKer,
]

const panels: HawaPanel[] = []

// Registering panels
for (const index in Panels) {
  const panel = new Panels[index]()
  // panel.name = panel.constructor.name
  panel.init = panel.init || {}
  panel.init.component = panel.name
  panel.init.title = panel.title
  panel.init.layout = panel.init.layout || {
    x: 1000,
    y: 1000,
    h: 20,
    w: 24,
    i: new Date().valueOf().toString(),
  }
  panel.init.query = panel.init.query || []

  // eslint-disable-next-line
  if (typeof (Vue as any).options.components[panel.name] === 'undefined') {
    Vue.component(panel.name, panel.component)
    Vue.component(panel.name + 'Editor', panel.editor)
  } else {
    console.log('Component', panel.name, 'is exist')
  }

  panels.push(panel)
}

export { panels }
